import { render, staticRenderFns } from "./activity-paper-score.vue?vue&type=template&id=45a8a776"
import script from "./activity-paper-score.vue?vue&type=script&lang=js"
export * from "./activity-paper-score.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports